import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function cancelResourceBooking(bookingId: string) {
  return getSMPBackendAPIAdmin().resourceBookingsControllerConfirmCancelV1(bookingId);
}

export function useCancelResourceBooking() {
  return useMutation({ mutationFn: cancelResourceBooking });
}
